/**
 * Badge — colored pill label.
 * variant: default | success | warning | danger
 * size:    sm (default) | lg
 */
import React from 'react';

export default function Badge({ children, variant = 'default', size = 'sm' }) {
  return (
    <span className={`badge badge-${variant} badge-${size}`}>{children}</span>
  );
}
